import { STATUS } from '../../../constants/Config';
import BaseConstantSelectBox from '../../components/BaseConstantSelectBox';

class MarriedStatusSelectBox extends BaseConstantSelectBox {
    constructor(props) {
        super(props);

        this.initData = STATUS;
    }

    onDataChanged(e) {
        if (e.value !== null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: e.value
            });
        }
        if (e.value === null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: ''
            });
        }
    }
}

export default MarriedStatusSelectBox;
